import { memo } from "react";

function LineOfBestFit() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" version="1.1">
      <path d="M4 4L4 20L22 20" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <g transform="rotate(-40.37 10.03 11.96) translate(1,2)">
        {/* Line of best fit */}
        <path d="M-0.0458,11.9571 H20.1095" stroke="currentColor" strokeWidth="1.75" />

        {/* Circular points along the line */}
        <circle
          cx="6"
          cy="9.1"
          r="0.6"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle
          cx="15"
          cy="15.2"
          r="0.6"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle
          cx="8"
          cy="15"
          r="0.6"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle
          cx="12"
          cy="8"
          r="0.6"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle
          cx="18"
          cy="9"
          r="0.6"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

export default memo(LineOfBestFit);
